export default "/fonts/vendor/@fontsource/lato/files/lato-latin-900-normal.woff?2c192d91b0e567a0fcf09177ced7b98f";